import classes from '../../styles/tts/ttsModal.module.scss'
import sidebarClasses from '../../styles/tts/ttsSidebarVoices.module.scss'
import cn from 'classnames'
import { EmotionListConfig } from './config'
import { FC, useCallback, useMemo, useState } from 'react'
import { useDispatch } from '../../hooks/redux'
import { ttsSetEmotionVoice } from '../../store/slices/tts/ttsSlice'
import { PortalTooltip } from '../../components/tooltip/portalTooltip'
import { CustomIcon } from '../../components/customIcon/customIcon'

export const EmotionList: FC<{
  selectedEmotion: string
  defaultEmotion?: string
  handleShowEmotions?: () => void
  showEmotions?: boolean
  emotions: string[] | null
  voice: string
}> = ({ selectedEmotion, defaultEmotion, voice, showEmotions, emotions, handleShowEmotions = () => {} }) => {
  const dispatch = useDispatch()
  const [hoveredEmotion, setHoveredEmotion] = useState<string | null>(null)

  const handleSelectEmotion = useCallback(
    (emotion: string) => {
      dispatch(ttsSetEmotionVoice({ name: voice, emotion }))
    },
    [dispatch, voice]
  )

  const undefinedEmoji = useMemo(() => EmotionListConfig.find((el) => el.name === 'undefined')?.url, [])
  const filteredEmotions = useMemo(() => {
    return Array.isArray(emotions)
      ? emotions.map((item) => {
          const found = EmotionListConfig.find((el) => el.name === item)
          return found || { name: item, tittle: item, url: undefinedEmoji || '', emoji: undefined }
        })
      : []
  }, [emotions])

  const isSingle = filteredEmotions.length <= 1

  return (
    <PortalTooltip
      classes={{ contentClassName: cn(sidebarClasses.ttsOverflowTooltipContent, sidebarClasses.ttsEmotionTooltip) }}
      triggerMode={isSingle ? 'hover' : 'click'}
      handleClose={handleShowEmotions}
      placement="bottom-middle"
      hideTooltip={isSingle ? false : !showEmotions}
      tooltipContent={
        isSingle ? (
          <span>{filteredEmotions[0]?.tittle ?? selectedEmotion}</span>
        ) : (
          <div className={classes.emojiDropdownWrapper}>
            {filteredEmotions?.map(({ name: emotion, url, tittle, emoji }) => {
              const isSelected = selectedEmotion === emotion
              const isDefaultEmotion = defaultEmotion === emotion

              return (
                <div
                  key={emotion}
                  className={cn(classes.emojiDropdownItem, isSelected && classes.emojiDropdownActiveItem)}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleSelectEmotion(emotion)
                    handleShowEmotions()
                  }}
                  onMouseEnter={() => setHoveredEmotion(emotion)}
                  onMouseLeave={() => setHoveredEmotion(null)}
                >
                  {url ? (
                    <img className={classes.emojiDropdownImg} src={url} alt={tittle} />
                  ) : (
                    <span className={classes.emojiDropdownImg} style={{ fontSize: 20, lineHeight: 1 }}>
                      {emoji}
                    </span>
                  )}
                  <span className={classes.emojiDropdownName}>{tittle}</span>
                  <span className={classes.emojiDropdownMark}>{isDefaultEmotion && <CustomIcon icon="crown" />}</span>
                </div>
              )
            })}
          </div>
        )
      }
    >
      {(() => {
        const found = EmotionListConfig.find((item) => item.name === selectedEmotion)
        return found?.url ? (
          <img onClick={handleShowEmotions} width={20} height={20} src={found.url} />
        ) : (
          <span onClick={handleShowEmotions} style={{ fontSize: 20, lineHeight: 1, cursor: 'pointer' }}>
            {found?.emoji}
          </span>
        )
      })()}
    </PortalTooltip>
  )
}
